export module Url {
  export const parseAndMapParams = <T extends any>(search?: string): T => {
    return Array.from(new URLSearchParams(search)).reduce(
      (o, i) => ({ ...o, [i[0]]: i[1] }),
      {}
    ) as T
  }
}
